// Яндекс Метрика. Id счётчика — из <meta name="yandex-metrika-id"> (ENV YANDEX_METRIKA_ID),
// без него ничего не грузится. Inertia меняет страницы без перезагрузки, поэтому просмотры
// отправляются вручную на каждый navigate (он же срабатывает и при первой загрузке).
import { router } from "@inertiajs/vue3"

export function setupMetrika() {
  const id = Number(document.querySelector('meta[name="yandex-metrika-id"]')?.content)
  if (!id) return

  window.ym = window.ym || function () { (window.ym.a = window.ym.a || []).push(arguments) }
  window.ym.l = Date.now()
  const script = document.createElement("script")
  script.async = true
  script.src = "https://mc.yandex.ru/metrika/tag.js"
  document.head.appendChild(script)

  // webvisor выключен: запись сессий захватывает содержимое форм. Включать только вместе с
  // запретом записи полей ввода в настройках счётчика.
  window.ym(id, "init", { defer: true, clickmap: true, trackLinks: true, accurateTrackBounce: true, webvisor: false })

  let referer = document.referrer
  router.on("navigate", (event) => {
    const url = new URL(event.detail.page.url, window.location.origin).href
    window.ym(id, "hit", url, { referer, title: document.title })
    referer = url
  })
}
